import { gql } from "@apollo/client";

export const GET_RATING = gql`
  query getRating($input: RateInput!) {
    rating(input: $input) {
      type
      resourceType
      message
      sentiment
      rating
      resourceId
      category
    }
  }
`;
